"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var appenders_1 = __importDefault(require("./appenders"));
var defaultContext = {};
var printLoggerErrorInfo = function (message, data, err) {
    return console.log("Error occurred while trying to log message [" + message + "] with data [" + data + "].\nError [" + err.message + "]");
};
var doLog = function (level, message, error, data) {
    return appenders_1.default(level, message, error, __assign(__assign({}, defaultContext), data)).catch(function (err) { return printLoggerErrorInfo(message, error, err); });
};
var logger = {
    error: function (message, error, data) {
        doLog('error', message, error, data);
    },
    warning: function (message, data) {
        doLog('warn', message, data);
    },
    warn: function (message, data) {
        doLog('warn', message, data);
    },
    info: function (message, data) {
        doLog('info', message, data);
    },
    debug: function (message, data) {
        doLog('debug', message, data);
    },
    updateContext: function (updater) {
        defaultContext = updater(defaultContext);
    },
};
exports.default = logger;
function initContext(context) {
    defaultContext = context;
}
exports.initContext = initContext;
//# sourceMappingURL=logger.js.map